// Images uploaded through the admin (gallery, team, reviews) are stored as
// the original files: often multi-megabyte PNGs, sometimes as http:// URLs.
// Served as-is they were the bulk of the homepage's 8 MB and flagged as
// mixed content. These helpers turn an upload URL into a right-sized one.

const CLOUDINARY_UPLOAD = '/image/upload/'

/** Always https: an https page must not request http images. */
export function httpsUrl(url) {
  return typeof url === 'string' ? url.replace(/^http:\/\//i, 'https://') : url
}

export function isCloudinary(url) {
  return typeof url === 'string' && /^https?:\/\/res\.cloudinary\.com\//i.test(url) && url.includes(CLOUDINARY_UPLOAD)
}

/**
 * A URL for `url` at most `width` CSS pixels wide (doubled for sharp
 * screens). Cloudinary resizes and picks WebP/AVIF itself via URL
 * parameters; other hosts come back unchanged (https) for next/image or the
 * browser to handle.
 */
export function sizedImageUrl(url, width) {
  const secure = httpsUrl(url)
  if (!isCloudinary(secure)) return secure
  const [head, rest] = secure.split(CLOUDINARY_UPLOAD)
  // Already has a transformation (e.g. "c_fill,w_300/v123/..."): leave it.
  if (/^[a-z]{1,3}_[^/]*\//.test(rest)) return secure
  return `${head}${CLOUDINARY_UPLOAD}f_auto,q_auto,c_limit,w_${Math.round(width * 2)}/${rest}`
}

/**
 * Props for next/image from an upload URL: Cloudinary does its own resizing
 * (so next/image passes it through), hosts allow-listed in next.config.ts are
 * optimised by Next, anything else is shown as-is.
 */
const NEXT_OPTIMISED_HOSTS = ['assets.cdn.filesafe.space', 'storage.googleapis.com']

export function remoteImageProps(url, width) {
  const src = sizedImageUrl(url, width)
  if (typeof src !== 'string' || src.startsWith('/')) return { src, unoptimized: false }
  if (isCloudinary(src)) return { src, unoptimized: true }
  let host = ''
  try { host = new URL(src).hostname } catch { /* not a URL */ }
  return { src, unoptimized: !NEXT_OPTIMISED_HOSTS.includes(host) }
}
